<main class="page">
  <section class="hero" aria-labelledby="inicio">
    <div>
      <h1 id="inicio">Hola, {{ guestName }}.</h1>
    </div>
  </section>

  <section class="section intro" aria-labelledby="invitacion">
    <div class="container intro-grid">
      <div class="couple-art" aria-hidden="true">
        <p class="ribbon">&iexcl;Nos casamos!</p>
        <img class="car" src="https://paulayjhon.my.canva.site/_assets/media/472fdf0ea4de0691c7b6333912776535.png" alt="" />
        <p class="couple-names">Paula y<br />Jhon Alex</p>
        <img class="rings" src="https://paulayjhon.my.canva.site/_assets/media/9f89a4d68ae05e2e877c6af72edf3241.png" alt="" />
      </div>

      <div class="intro-copy">
        <p id="invitacion">Tenemos el gusto de invitarte en este d&iacute;a tan importante de nuestras vidas, nuestro matrimonio eclesi&aacute;stico.</p>
        <div class="divider" aria-hidden="true">&hearts;</div>
        <p class="event-meta">
          Parroquia San Miguel Arc&aacute;ngel<br />
          V&iacute;a Cerritos, Entrada a Galicia<br />
          5 septiembre 2026<br />
          2:00 p.m.
        </p>
        <p class="note">Brindis posterior a la ceremonia.</p>
        <div class="actions">
          <a
            class="button"
            href="https://maps.google.com/?q=Parroquia%20San%20Miguel%20Arcangel%20Via%20Cerritos%20Entrada%20a%20Galicia"
            target="_blank"
            rel="noreferrer"
            >Ver ubicaci&oacute;n</a
          >
          <a class="button secondary" href="#confirmar">Confirmar asistencia</a>
        </div>
      </div>
    </div>
  </section>

  <section class="section details" aria-labelledby="detalles">
    <div class="container">
      <h2 class="section-heading" id="detalles">Los detalles</h2>
      <div class="details-grid">
        <article class="detail-card">
          <h3>Ceremonia</h3>
          <p>La ceremonia empieza a las 2:00 p.m. Sugerimos llegar con al menos 15 minutos de anticipaci&oacute;n para estar acomodados a tiempo.</p>
        </article>

        <article class="detail-card">
          <h3>Vestuario</h3>
          <p>Se recomienda un atuendo formal y sobrio, acorde con el recinto. A las mujeres, agradecemos evitar el color blanco, as&iacute; como escotes pronunciados, transparencias o prendas muy cortas. A los hombres, les sugerimos pantal&oacute;n de sastre y evitar prendas demasiado informales como camisetas deportivas o gorras; tambi&eacute;n les solicitamos amablemente evitar los trajes de color azul.</p>
        </article>

        <article class="detail-card">
          <h3>El brindis</h3>
          <p>Ofreceremos un brindis a las 4:00 p.m. en La Chocolera Picnic, Km 7 V&iacute;a Cerritos-Pereira. Se servir&aacute; una bebida acompa&ntilde;ada de una especialidad de la casa. <strong>Los consumos adicionales ser&aacute;n por cuenta de cada invitado.</strong></p>
        </article>

        <article class="detail-card small">
          <h3>Ni&ntilde;os</h3>
          <p>Los ni&ntilde;os son bienvenidos. &ldquo;Abre mis ojos para que contemple las maravillas de tu ense&ntilde;anza.&rdquo; Salmos 119:18.<br /><br /><strong>Por favor deja tus mascotas en casa.</strong></p>
        </article>

        <article class="detail-card small">
          <h3>Fotograf&iacute;a</h3>
          <p>Agradecemos no tomar fotos durante la ceremonia, por respeto al sagrado sacramento. Habr&aacute; un momento destinado para fotos con los invitados y un equipo profesional registrar&aacute; el evento.</p>
        </article>
      </div>
    </div>
  </section>

  <section class="section rsvp" id="confirmar" aria-labelledby="rsvp-title">
    <div class="container">
      <h2 id="rsvp-title">Te agradecemos confirmar tu asistencia</h2>
      <p>Antes del 15 de agosto.</p>
      <div class="rsvp-actions">
        <a
          class="button"
          href="https://wa.me/573105293217?text=Hola,%20confirmo%20mi%20asistencia%20a%20la%20boda%20de%20Paula%20y%20Jhon%20Alex.%20%C2%A1Gracias%20por%20la%20invitaci%C3%B3n!"
          target="_blank"
          rel="noreferrer"
          >Asistir&eacute;</a
        >
        <a
          class="button"
          href="https://wa.me/573105293217?text=Hola,%20lamento%20que%20no%20podr%C3%A9%20asistir%20a%20la%20boda%20de%20Paula%20y%20Jhon%20Alex.%20Gracias%20por%20la%20invitaci%C3%B3n."
          target="_blank"
          rel="noreferrer"
          >No asistir&eacute;</a
        >
      </div>
      <p class="signature">&iexcl;Te esperamos!</p>
    </div>
  </section>
</main>

<footer class="footer">Paula y Jhon Alex &middot; 5 septiembre 2026</footer>
